import { useMutation } from '@tanstack/react-query'
import {
  type PostTaskSchedulesRequestBody,
  type TaskScheduleFieldError,
  TasksApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  type HTTPError,
  handleHTTPError,
} from 'src/state/middleware/saga/handleHttpError'

/**
 * 作業指示の作成（POST /taskSchedules）の 400。共通の HTTPError に加えて、
 * 受理できなかった欄と理由が fieldErrors に並ぶ（body の形そのものが読めないときは無い）。
 */
export type TaskScheduleHTTPError = HTTPError & {
  fieldErrors?: TaskScheduleFieldError[]
}

/**
 * 作業指示の作成（POST /taskSchedules）。成功すると採番された id を含む作業指示が返る。
 * 400 のときは fieldErrors を欄に振り分けて出し、fieldErrors が無ければ errors をそのまま出す。
 */
export const useCreateTaskSchedule = () =>
  useMutation({
    mutationFn: (body: PostTaskSchedulesRequestBody) =>
      baseClient
        .getApi(TasksApi)
        .postTaskSchedules({ postTaskSchedulesRequestBody: body })
        .catch(handleHTTPError),
  })

export const isHTTPError = (error: unknown): error is TaskScheduleHTTPError =>
  typeof error === 'object' &&
  error !== null &&
  'errors' in error &&
  Array.isArray((error as HTTPError).errors)
